// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cancelledDocuments_oky8O {
  padding: 20px;
  .documents_Iw5E7 {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 300px;
    align-items: center;
    justify-content: center;
  }

  .document_DRrbg {
    display: flex;
    align-items: center;
    position: relative;
    gap: 10px;
    color: var(--009f7a-color);
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; 
    .OptionDots_gdiLy {
      transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -o-transform: rotate(90deg);
      cursor: pointer;
    }
  }
  .errors_NCt2V {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    p,
    span {
      color: #222;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 21px;
    }
  }
}

.optionsPopupContainer_ZSm3f {
  position: absolute;
  z-index: 9999;
  bottom: 0px;
  left: 385px;
}

.optionsPopupOption_nj5KP {
  display: flex;
  align-items: center;
  gap: 5px;
}

.dropdown_x3Ida {
  width: 30%;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ApproveDocument/ApproveDocument.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB;MACE,wBAAwB;MACxB,gCAAgC;MAChC,6BAA6B;MAC7B,4BAA4B;MAC5B,2BAA2B;MAC3B,eAAe;IACjB;EACF;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;;MAEE,WAAW;MACX,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".cancelledDocuments {\n  padding: 20px;\n  .documents {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    min-height: 300px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .document {\n    display: flex;\n    align-items: center;\n    position: relative;\n    gap: 10px;\n    color: var(--009f7a-color);\n    font-family: Inter;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px; \n    .OptionDots {\n      transform: rotate(90deg);\n      -webkit-transform: rotate(90deg);\n      -moz-transform: rotate(90deg);\n      -ms-transform: rotate(90deg);\n      -o-transform: rotate(90deg);\n      cursor: pointer;\n    }\n  }\n  .errors {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    p,\n    span {\n      color: #222;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 21px;\n    }\n  }\n}\n\n.optionsPopupContainer {\n  position: absolute;\n  z-index: 9999;\n  bottom: 0px;\n  left: 385px;\n}\n\n.optionsPopupOption {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.dropdown {\n  width: 30%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cancelledDocuments": `cancelledDocuments_oky8O`,
	"documents": `documents_Iw5E7`,
	"document": `document_DRrbg`,
	"OptionDots": `OptionDots_gdiLy`,
	"errors": `errors_NCt2V`,
	"optionsPopupContainer": `optionsPopupContainer_ZSm3f`,
	"optionsPopupOption": `optionsPopupOption_nj5KP`,
	"dropdown": `dropdown_x3Ida`
};
export default ___CSS_LOADER_EXPORT___;
